import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Gdpr } from '@mkp/gdpr/models';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonWrapper,
  FeedbackModule,
} from '@mkp/shared/ui-library';
import { TranslateModule } from '@ngx-translate/core';
import { GdprLinkPipe } from '../gdpr-link/gdpr-link.pipe';

const DEFAULT_BUTTON_CONFIG: Button = {
  mobileFullWidth: true,
  size: ButtonSize.Small,
};

@Component({
  templateUrl: 'gdpr-functional-dialog-content.component.html',
  styleUrl: '../gdpr-dialog-content/gdpr-dialog-content.component.scss',
  imports: [MatDialogModule, TranslateModule, GdprLinkPipe, FeedbackModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GdprFunctionalDialogContentComponent {
  private dialogRef =
    inject<MatDialogRef<GdprFunctionalDialogContentComponent, Partial<Gdpr>>>(MatDialogRef);

  readonly cancelBtnConfig: ButtonWrapper = {
    config: {
      ...DEFAULT_BUTTON_CONFIG,
      color: ButtonColor.Tertiary,
      disableRipple: true,
    },
    content: {
      label: 'GDPR.COOKIE-DIALOG.BUTTON.DISMISS',
    },
  };

  readonly gdprBtnConfig: ButtonWrapper = {
    config: {
      ...DEFAULT_BUTTON_CONFIG,
      color: ButtonColor.Primary,
    },
    content: {
      label: 'GDPR.MODAL.BUTTON.ACCEPT-FUNCTIONAL-COOKIES',
    },
  };

  submit() {
    this.dialogRef.close({
      functional: true,
    });
  }

  dismiss() {
    this.dialogRef.close();
  }
}
